import React, { ReactElement, ReactNode } from "react";
import FormField from "./FormField";
import { Box, FormGroup } from "@mui/material";

export type FormGroupWithInlineButtonsProps = {
  children: ReactNode;
  formField: ReactElement<typeof FormField>;
};

export function FormGroupWithInlineButtons({ children, formField }: FormGroupWithInlineButtonsProps) {
  return (
    <FormGroup
      row
      sx={(theme) => ({
        width: 1,
        alignItems: "flex-start",
        [theme.breakpoints.down("lg")]: {
          "& .inline-button": {
            border: "1px solid white",
            borderTopRightRadius: 0,
            borderTopLeftRadius: 0,
            borderTop: "none",
            boxShadow: "inset 0 2px 4px 0 #666",
          },
          "& .inline-button:last-of-type": {
            borderBottomRightRadius: "5px",
            marginRight: "2px",
          },
          "& .inline-button:first-of-type": {
            borderBottomLeftRadius: "5px",
            marginLeft: "2px",
          },
        },
        [theme.breakpoints.up("lg")]: {
          "& fieldset": {
            borderTopRightRadius: 0,
            borderBottomRightRadius: 0,
          },
          "& .inline-button": {
            borderRadius: 0,
            border: "1px solid transparent",
          },
          "& .inline-button:last-of-type": {
            borderTopRightRadius: "3px",
            borderBottomRightRadius: "3px",
            borderLeft: "1px solid white",
          },
        },
      })}
    >
      <Box sx={{ flex: 1 }}>{formField}</Box>
      <Box
        sx={(theme) => ({
          [theme.breakpoints.down("lg")]: {
            display: "flex",
            width: 1,
            "& .inline-button": {
              flex: 1,
            },
          },
          [theme.breakpoints.up("lg")]: {
            display: "contents",
          },
        })}
      >
        {children}
      </Box>
    </FormGroup>
  );
}
